var map = {
	"./2-1.png": 6770,
	"./2-2.png": 1913,
	"./2-3.png": 7088,
	"./2-4.png": 5743,
	"./3-1.png": 9351,
	"./3-2.png": 620,
	"./3-3.png": 8133,
	"./3-4.png": 3466,
	"./4-1.png": 8696,
	"./4-2.png": 3187,
	"./4-3.png": 4330,
	"./4-4.png": 1378,
	"./5-1.png": 517,
	"./5-2.png": 8718,
	"./5-3.png": 1735,
	"./5-4.png": 216,
	"./6-1.png": 4966,
	"./6-2.png": 2941,
	"./6-3.png": 6644,
	"./6-4.png": 8299,
	"./6-5.png": 434,
	"./6-6.png": 1145,
	"./7-1.png": 1931,
	"./7-2.png": 8432,
	"./7-3.png": 8985,
	"./7-4.png": 5910,
	"./7-5.png": 4927,
	"./7-6.png": 6020,
	"./8-1.png": 8588,
	"./8-2.png": 4999,
	"./8-3.png": 6686,
	"./8-4.png": 7697
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2303;